import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Once Way Travel";
const BASE = "https://oncewaytravel.com";
const DEFAULT_IMG =
  "https://customer-assets-jai6qajn.emergentagent.net/job_71357793-066d-495c-9261-d3cf17458b15/artifacts/uaudh6f5_ONceWay%20Logo.png";

/**
 * Per-page SEO tags. Renders title, description, canonical, Open Graph,
 * Twitter cards and optional JSON-LD structured data.
 */
export default function Seo({ title, description, path = "", image, type = "website", jsonLd }) {
  const fullTitle = title ? `${title} · ${SITE}` : SITE;
  const url = `${BASE}${path}`;
  const img = image || DEFAULT_IMG;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
